import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaintBrush: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"paint-brush, design, color, appearance"} maskId="square-filled-radius-0-stroke-1-IconPaintBrush"><path d="M20 15H14.5L14.8008 19.5068C14.9087 21.1267 13.6235 22.5 12 22.5C10.3765 22.5 9.09135 21.1267 9.19922 19.5068L9.5 15H4V12H20V15Z" fill="currentColor"/><path d="M8.5 2L10 4L11.5 2H20V11H4V2H8.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPaintBrush;
